function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
    if (this.input.step) {
      const step = parseInt(this.input.step);
      const quantity = parseInt(this.input.value);
      const incr = quantity / step;

      if (incr % 1 != 0) {
        this.input.value = this.input.min;
      }
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)',
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.initialize();
  }

  connectedCallback() {
    this.createObserver();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  initialize() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    poster.addEventListener('click', () => this.loadContent());

    if (this.dataset.autoplay === 'true' && this.isAboveFold()) {
      poster.click();
    }
  }

  isAboveFold() {
    const rect = this.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName === 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play();
      }
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadContent();
            const video = this.querySelector('video');
            if (video && video.hasAttribute('autoplay')) {
              video.play();
            }
          } else {
            const video = this.querySelector('video');
            if (video) {
              video.pause();
            }
          }
        });
      },
      { threshold: 0.5 },
    ); // Threshold set to 0.5 to ensure half the video is visible before playing

    this.observer.observe(this);
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateMaxFromSelectedSwatch();
    this.updateStickyAddToCart();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if (!this.currentVariant) {
      const selectedVariantId = Number(this.options[0]);

      this.currentVariant = this.getVariantData().find((variant) => variant.id === selectedVariantId);
    }
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);

      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true),
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-sticky`,
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const productFormsAdvance = document.querySelectorAll(
      `#product-form-${this.dataset.section}_advance, #product-form-installment-${this.dataset.section}`,
    );

    if (productFormsAdvance) {
      productFormsAdvance.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        const stickyPriceDestination = document.getElementById(`price-${this.dataset.section}-sticky`);
        const stickyPriceSource = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);

        const payLaterSource = html.getElementById(
          `Pay-later-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const payLaterDestination = document.getElementById(`Pay-later-${this.dataset.section}`);

        const colourCodeSource = html.getElementById(
          `Colour_code-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const colourCodeDestination = document.getElementById(`Colour_code-${this.dataset.section}`);

        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        const beddingVariantsSource = html.querySelector(
          `variant-selects-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          } .bedding`,
        );

        const beddingVariantsDestination = document.querySelector(
          `variant-selects-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          } .bedding`,
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        const memberPricingProperty = document.getElementById(`Price-Member-${this.dataset.section}`);
        const rulePricingProperty = document.getElementById(`Price-Rule-${this.dataset.section}`);

        if (memberPricingProperty && rulePricingProperty) {
          memberPricingProperty.value = source.querySelector('#memberPrice').value;
          // rulePricingProperty.value = source.querySelector('#rulePrice').value;
        }

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (stickyPriceSource && stickyPriceDestination) stickyPriceDestination.innerHTML = stickyPriceSource.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (colourCodeSource && colourCodeDestination) {
          colourCodeDestination.innerHTML = colourCodeSource.innerHTML;
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (payLaterSource && payLaterDestination) {
          payLaterDestination.innerHTML = payLaterSource.innerHTML;
        }

        if (beddingVariantsSource && beddingVariantsDestination) {
          beddingVariantsDestination.innerHTML = beddingVariantsSource.innerHTML;
        }

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      // Members-only products keep their "Members only" label instead of "Sold out"
      if (addButton.dataset.lockedLabel) {
        addButtonText.textContent = addButton.dataset.lockedLabel;
      } else if (text) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    // if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    // if (sku) sku.classList.add('hidden');
    // if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateMaxFromSelectedSwatch() {
    const checked = this.querySelector('fieldset.product-form__input--swatch input[type="radio"]:checked');
    if (!checked) return;

    const label = this.querySelector(`label[for="${checked.id}"]`);
    const max = label?.dataset?.max;

    const target = document.querySelector('.product__info-wrapper [name="max-quantity"]');
    if (!target) return;

    if (max) {
      target.value = max;
    } else {
      target.value = null;
    }
  }

  updateStickyAddToCart() {
    const productStickyContainer = document.getElementById('FloatingAtcBar');

    // Exit early if not on product page (e.g. quick view)
    if (!productStickyContainer) return;

    const productStickySelect = productStickyContainer.querySelector('.select__select');

    // The floating bar no longer carries its own variant select / add-to-cart
    // state — it just opens the quick-add modal — so there's nothing to sync.
    if (!productStickySelect) return;

    const productStickyATCB = productStickyContainer.querySelector('.button--add-to-cart');
    const productStickyATCBT = productStickyContainer.querySelector('.button--add-to-cart span');

    if (this.currentVariant) {
      productStickySelect.value = this.currentVariant.id;
      productStickyATCB.disabled = false;
      productStickyATCBT.textContent = 'Add to cart';
    } else {
      productStickyATCB.disabled = true;
      productStickyATCBT.textContent = 'Unavailable';
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class DonationSelect extends HTMLElement {
  constructor() {
    super();
    this.button = document.querySelector('.donate__submit');
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        element.value !== 'Maybe later'
          ? this.parentElement.querySelector('.donate__submit').removeAttribute('disabled')
          : this.parentElement.querySelector('.donate__submit').setAttribute('disabled', true);
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll('#donate-form');
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('donation-selects', DonationSelect);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class NavbarComponent extends HTMLElement {
  constructor() {
    super();

    this.search_menu = this.querySelector('#NavSearch');
    this.header = document.querySelector('header-drawer');
    const header_search = document.querySelector('.header__search');
    const header_search_input = document.querySelector('.search__input');
    const body = document.querySelector('body');
    this.menu_detail = this.header.querySelector('details');

    this.search_menu.addEventListener('click', () => {
      header_search.classList.toggle('search-opened');
      body.classList.toggle('ss-search-opened');
      if (header_search.classList.contains('search-opened')) {
        header_search_input.focus();
        const slideUpPopups = document.querySelectorAll('slide-up-popup');
        slideUpPopups.forEach((pop) => {
          if (pop.classList.contains('show')) {
            closeSlideUpPopup(pop);
          }
        });
      } else {
        header_search_input.blur();
        header_search_input.value = '';
      }
    });

    header_search_input.addEventListener('click', function () {
      header_search.classList.add('search-opened');
      body.classList.add('ss-search-opened');
    });

    this.initScrollVisibility();
  }

  // Hides the bar while the customer is actively scrolling down, and only
  // slides it back into view when they scroll up or pause scrolling for a
  // few seconds.
  initScrollVisibility() {
    const pauseDelay = 3000;

    let lastScrollY = window.scrollY;
    let ticking = false;
    let pauseTimer = null;

    // Mirrors state onto <body> so other fixed/floating elements (e.g. the
    // floating add-to-cart bar) can reposition themselves depending on
    // whether this bar is currently taking up space at the bottom.
    const show = () => {
      this.classList.remove('nav--hidden');
      document.body.classList.remove('mobile-nav-hidden');
    };
    const hide = () => {
      this.classList.add('nav--hidden');
      document.body.classList.add('mobile-nav-hidden');
    };

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        hide();
      } else if (currentScrollY < lastScrollY) {
        show();
      }

      lastScrollY = currentScrollY;

      clearTimeout(pauseTimer);
      pauseTimer = setTimeout(show, pauseDelay);

      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(handleScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
  }
}

customElements.define('navbar-component', NavbarComponent);

class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.readContent = this.querySelector('.read-content');
    this.toggle = this.querySelector('.toggle-more-less');

    this.innerContent = this.readContent.querySelector('.read-inner-content');
    if (this.innerContent.offsetHeight > 150) {
      this.classList.add('read-more-content');
    }

    this.isExpanded = false;

    this.toggle.addEventListener('click', this.toggleContent.bind(this));
  }

  toggleContent() {
    if (this.isExpanded) {
      this.readContent.classList.remove('open');
      this.toggle.textContent = 'Read more';
    } else {
      this.readContent.classList.add('open');
      this.toggle.textContent = 'Read less';
    }

    this.isExpanded = !this.isExpanded;
  }
}

customElements.define('read-more', ReadMore);

class ReadMoreMobile extends HTMLElement {
  constructor() {
    super();

    this.readContent = this.querySelector('.read-content');
    this.toggle = this.querySelector('.toggle-more-less');

    this.innerContent = this.readContent.querySelector('.read-inner-content');
    if (this.innerContent.offsetHeight > 150) {
      this.classList.add('read-more-content');
    }

    this.isExpanded = false;

    this.toggle.addEventListener('click', this.toggleContent.bind(this));
  }

  toggleContent() {
    if (this.isExpanded) {
      this.readContent.classList.remove('open');
      this.toggle.textContent = 'Read more';
    } else {
      this.readContent.classList.add('open');
      this.toggle.textContent = 'Read less';
    }

    this.isExpanded = !this.isExpanded;
  }
}

customElements.define('read-more-mobile', ReadMoreMobile);

class SlideUpPopup extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.shadowRoot.innerHTML = `
      <style>
        .close-button {
          position: absolute;
          top: 6px;
          right: 16px;
          background: transparent;
          border: none;
          font-size: 32px;
          cursor: pointer;
          color: #000;
        }
      </style>
      <button class="close-button" aria-label="Close Popup">&times;</button>
      <slot></slot>
    `;
  }

  connectedCallback() {
    // Close button click
    this.shadowRoot.querySelector('.close-button').addEventListener('click', () => this.close());
  }

  toggle() {
    if (this.classList.contains('show')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    document.querySelectorAll('slide-up-popup').forEach((popup) => {
      if (popup !== this) popup.close();
    });
    this.classList.add('show');
    document.querySelector('html').style.overflow = 'hidden';
    document.querySelector('body').style.overflow = 'hidden';
    document.body.insertAdjacentHTML('beforeend', '<div class="slide-up-overlay"></div>');
  }

  close() {
    closeSlideUpPopup(this);
    this.classList.remove('show');
    document.querySelector('html').style.overflow = 'auto';
    document.querySelector('body').style.overflow = 'auto';
    if (document.querySelector('.slide-up-overlay')) {
      document.querySelector('.slide-up-overlay').remove();
    }
  }
}

customElements.define('slide-up-popup', SlideUpPopup);

function closeSlideUpPopup(el) {
  el.classList.remove('show');
  document.querySelector('html').style.overflow = 'auto';
  document.querySelector('body').style.overflow = 'auto';
  if (document.querySelector('.slide-up-overlay')) {
    document.querySelector('.slide-up-overlay').remove();
  }
}

document.addEventListener('click', (e) => {
  if (e.target.matches('.open-mobile-slide')) {
    const targetId = e.target.getAttribute('data-popup');
    const popup = document.querySelector(`slide-up-popup[popup-id="${targetId}"]`);

    document.body.classList.remove('ss-search-opened');
    document.querySelector('.header__search').classList.remove('search-opened');

    if (popup) {
      popup.toggle();
    }
  }
});

// Auto-detecting the visitor's closest store used to go through an IP
// geolocation API (ipapi.co), but its free tier is capped at 1,000
// requests/day and total site traffic — not just duplicate calls per page —
// was blowing through that, causing 429s for guests on their very first
// request. The browser's own Geolocation API replaces it: no rate limit,
// more accurate, and the browser remembers the permission decision per
// site (e.g. Chrome won't re-prompt someone who already blocked it — we
// don't need to track that ourselves). If permission is denied or
// unavailable, we simply don't auto-detect a store; manually entering a
// postcode still works exactly as before.
//
// Shared across every <store-locator-widget> instance on the page (the
// desktop header one and the mobile menu one both mount on every guest
// pageview) so we only ever trigger ONE permission prompt / lookup per
// page load instead of one per instance.
let autoDetectCoordsPromise = null;

function detectLocationFromBrowser() {
  if (!autoDetectCoordsPromise) {
    autoDetectCoordsPromise = new Promise((resolve) => {
      if (!('geolocation' in navigator)) {
        resolve(null);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          // PERMISSION_DENIED, POSITION_UNAVAILABLE, or TIMEOUT — none of
          // these are errors worth surfacing loudly, they just mean we
          // can't auto-detect a store this visit.
          console.log('Geolocation unavailable:', error.message);
          resolve(null);
        },
        {
          // Suburb-level accuracy is plenty for "which store is closest" —
          // high accuracy GPS is slower and unnecessary here.
          enableHighAccuracy: false,
          timeout: 8000,
          maximumAge: 10 * 60 * 1000, // reuse a fix from the last 10 minutes
        },
      );
    });
  }

  return autoDetectCoordsPromise;
}

// Shared the same way as detectLocationFromBrowser() above, but for the
// whole "figure out the visitor's closest store" flow — so the second
// widget instance doesn't hit the getClosest backend a second time for the
// same coordinates. updateHTML()/nearestMessage() already write to every
// widget on the page, not just the one that triggered the lookup, so both
// stay in sync from a single call.
let autoDetectClosestStorePromise = null;

function autoDetectClosestStore(widget) {
  if (!autoDetectClosestStorePromise) {
    autoDetectClosestStorePromise = detectLocationFromBrowser().then((coords) => {
      if (coords) {
        return widget.getCustomersClosestStore({ lat: coords.lat, lng: coords.lng });
      }
    });
  }

  return autoDetectClosestStorePromise;
}

class StoreLocatorWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const updateStoreButton = this.querySelector('.button--updateStore');
    // Scoped to `this`, so each <store-locator-widget> instance (e.g. the
    // desktop header one and the mobile menu one) reads its own input only.
    const updateStoreInput = this.querySelector('[name="customerPostCode"]');

    let locationData;

    if (localStorage.getItem('pickup_location')) {
      locationData = JSON.parse(localStorage.getItem('pickup_location'));
      this.updateHTML(locationData);
    }

    const postcode = updateStoreInput.value || locationData?.postcode;

    if (postcode == '' || postcode == null) {
      autoDetectClosestStore(this);
    }

    updateStoreButton.addEventListener('click', () => {
      if (updateStoreInput.value !== '' && updateStoreInput.value !== null) {
        this.getCustomersClosestStore({ postcode: updateStoreInput.value });
      }
    });
  }

  updateHTML(locationData) {
    const encodedDirections = encodeURIComponent(
      `${locationData.address} ${locationData.province} ${locationData.postcode}`,
    );

    const locationDetails = `
      ${locationData?.address}<br>
      ${locationData?.province}<br>
      ${locationData?.postcode}<br>
      <a class="link" href="https://www.google.com/maps/search/?api=1&query=${encodedDirections}" target="_blank" rel="noopener">Get Directions</a>
      <a class="link" href="tel:${locationData?.phone}">Call</a>
      <a href="${locationData?.store_page_url}" class="link">View store details</a>
    `;

    const labelText = locationData.is_pickup ? 'Free Pickup at Lincraft' : 'Your closest Lincraft';

    document.querySelectorAll('.closest-store span').forEach((el) => {
      el.textContent = labelText;
    });

    document.querySelectorAll('.closest-store strong').forEach((el) => {
      el.textContent = locationData?.name;
    });

    document.querySelectorAll('.current-store-details').forEach((el) => {
      el.innerHTML = locationDetails;
    });

    document.querySelectorAll('.store-location-message').forEach((el) => {
      el.textContent = locationData?.message;
    });
  }

  updateLocalStorage(locationData) {
    // localStorage.setItem('pickup_location_id', locationData?.shopify_id);
    // localStorage.setItem('pickup_location_postcode', locationData?.postcode);
    localStorage.setItem('pickup_location', JSON.stringify(locationData));
  }

  nearestMessage(locationData, payload) {
    if (!locationData) return;
    // Only makes sense for a manually-entered postcode that didn't match —
    // a geolocation-based lookup (lat/lng) is inherently "nearest", there's
    // no postcode to reference and no "sorry, not found" to apologise for.
    if (!payload?.postcode) return;

    const containers = document.querySelectorAll('.store-locate-container');

    containers.forEach((container) => {
      const oldMessage = container.querySelector('.nearest-store-message');
      if (oldMessage) oldMessage.remove();

      const messageEl = document.createElement('div');
      messageEl.classList.add('nearest-store-message');
      messageEl.style.marginTop = '.5rem';
      messageEl.style.fontSize = '13px';

      messageEl.textContent = `Oops! No Lincraft in ${payload.postcode} — but ${locationData.name} in ${locationData.postcode} is the closest one to you.`;

      container.appendChild(messageEl);
    });
  }

  getCustomersClosestStore(data) {
    // Guard against calling the backend with neither a postcode nor
    // coordinates (e.g. geolocation was denied/unavailable) — it can't do
    // anything with that and just returns a 400.
    const hasPostcode = !!data?.postcode;
    const hasCoords = data?.lat != null && data?.lng != null;
    if (!hasPostcode && !hasCoords) return;

    this.classList.add('loading');
    fetch(`${window.enhanceify.appUrl}/store_locations/getClosest`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((closestLocationResponse) => closestLocationResponse.json())
      .then((closestLocationResponse) => {
        const locationData = closestLocationResponse?.location;
        const toNearest = closestLocationResponse?.nearest;

        if (locationData) {
          this.updateHTML(locationData);
          this.updateLocalStorage(locationData);
        }

        if (locationData && toNearest) {
          this.nearestMessage(locationData, data);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.classList.remove('loading');
      });
  }
}

customElements.define('store-locator-widget', StoreLocatorWidget);

// Setting mobile drawer height
const mobile_navigation = document.querySelector('.mobile-navigation');

const become_member_container_x = document.querySelector('.become-member-container');
become_member_container_x
  ? document.documentElement.style.setProperty(
      '--mobile-nav-height',
      `${become_member_container_x.offsetHeight + mobile_navigation.offsetHeight}px`,
    )
  : document.documentElement.style.setProperty('--mobile-nav-height', `${mobile_navigation.offsetHeight}px`);

class FeedbackWidget extends HTMLElement {
  connectedCallback() {
    this.enhanceifyUrl = window.enhanceify.appUrl;

    this.btn = this.querySelector('#feedback-trigger');
    this.overlay = this.querySelector('#feedback-overlay');
    this.closeBtn = this.querySelector('#feedback-close');
    this.skipBtn = this.querySelector('#feedback-cancel');
    this.submitBtn = this.querySelector('#feedback-submit');
    this.expRow = this.querySelector('#feedback-exp-row');
    this.surveyView = this.querySelector('#feedback-survey-view');
    this.thanksView = this.querySelector('#feedback-thanks-view');
    this.commentField = this.querySelector('#feedback-comment');
    this.commentLabel = this.querySelector('label[for="feedback-comment"]');
    this.purposeField = this.querySelector('#feedback-purpose');
    this.emailField = this.querySelector('#feedback-email');

    if (!this.btn || !this.overlay) return;

    this.expScore = null;
    this.completedPurpose = null;
    this.commentOptionalText = this.commentLabel ? (this.commentLabel.querySelector('span')?.textContent ?? '') : '';

    this.buildScoreButtons();
    this.bindEvents();
  }

  buildScoreButtons() {
    for (let score = 0; score <= 10; score++) {
      const scoreBtn = document.createElement('button');
      scoreBtn.className = 'feedback-score-btn';
      scoreBtn.textContent = score;
      scoreBtn.setAttribute('type', 'button');
      scoreBtn.addEventListener('click', () => this.selectScore(score, scoreBtn));
      this.expRow.appendChild(scoreBtn);
    }
  }

  selectScore(score, scoreBtn) {
    this.expScore = score;
    this.expRow.querySelectorAll('.feedback-score-btn').forEach((el) => el.classList.remove('selected'));
    scoreBtn.classList.add('selected');
    this.updateCommentRequirement();
  }

  updateCommentRequirement() {
    const isLowScore = this.expScore !== null && this.expScore <= 4;
    this.commentField.required = isLowScore;
    this.commentField.classList.toggle('lnc-required', isLowScore);

    if (this.commentLabel) {
      const span = this.commentLabel.querySelector('span');
      if (span) span.textContent = isLowScore ? '(please let us know what went wrong)' : this.commentOptionalText;
    }

    if (!isLowScore) this.clearCommentError();
  }

  showCommentError() {
    this.commentField.classList.add('lnc-error');
    this.commentField.setAttribute('aria-invalid', 'true');
    this.commentField.focus();
  }

  clearCommentError() {
    this.commentField.classList.remove('lnc-error');
    this.commentField.removeAttribute('aria-invalid');
  }

  bindEvents() {
    this.btn.addEventListener('click', () => this.openModal());
    this.closeBtn.addEventListener('click', () => this.closeModal());
    this.skipBtn.addEventListener('click', () => this.closeModal());

    this.overlay.addEventListener('click', (event) => {
      if (event.target === this.overlay) this.closeModal();
    });

    this.commentField.addEventListener('input', () => {
      if (this.commentField.value.trim()) this.clearCommentError();
    });

    this.querySelectorAll('.feedback-completed-btn').forEach((completedBtn) => {
      completedBtn.addEventListener('click', () => this.selectCompletedPurpose(completedBtn));
    });

    this.submitBtn.addEventListener('click', () => this.submit());
  }

  selectCompletedPurpose(completedBtn) {
    this.completedPurpose = completedBtn.dataset.val;
    this.querySelectorAll('.feedback-completed-btn').forEach((el) => el.classList.remove('selected'));
    completedBtn.classList.add('selected');
  }

  openModal() {
    this.overlay.classList.add('open');
    this.overlay.style.display = 'flex';
    this.commentField.focus();
  }

  closeModal() {
    this.overlay.classList.remove('open');
    this.overlay.style.display = 'none';
  }

  buildPayload() {
    return {
      source: 'site_popup',
      experience_score: this.expScore,
      visit_purpose: this.purposeField.value || null,
      completed_purpose: this.completedPurpose,
      comment: this.commentField.value.trim() || null,
      customer_email: this.emailField.value.trim() || null,
      page_url: window.location.href,
    };
  }

  async submit() {
    if (this.commentField.required && !this.commentField.value.trim()) {
      this.showCommentError();
      return;
    }

    this.submitBtn.disabled = true;
    this.submitBtn.textContent = 'Submitting...';

    try {
      await fetch(`${this.enhanceifyUrl}/apps/feedback/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.buildPayload()),
      });
    } catch (error) {
      console.error('[feedback] submit error', error);
    }

    this.surveyView.style.display = 'none';
    this.thanksView.style.display = 'block';

    setTimeout(() => this.closeModal(), 2800);
  }
}

customElements.define('feedback-widget', FeedbackWidget);

fetch(`/cart.js`)
  .then((response) => response.json())
  .then((response) => {
    console.log('cart response', response);
  });

/**
 * Product card variant-pill image swap.
 * Hovering (or focusing) a colour swatch on a product card swaps the card's
 * main image to that variant's image. The swap persists after the pointer
 * leaves the card — it only changes again when a different pill is hovered.
 * Delegated on document so it works for cards rendered after page load
 * (filtered collections, infinite scroll, search results, etc.).
 *
 * To avoid a visible delay on the first hover, a card's variant images are
 * preloaded via <link rel="preload"> the moment the pointer/focus first
 * enters that card (not on page load, so it has no effect on initial page
 * speed). The preload uses the same srcset/sizes the real <img> uses, so the
 * browser fetches the exact resource it will need and the later swap is
 * served from cache instead of triggering a fresh network request.
 */
function preloadCardVariantImages(cardWrapper) {
  if (cardWrapper.dataset.variantImagesPreloaded) return;
  cardWrapper.dataset.variantImagesPreloaded = 'true';

  const mainImage = cardWrapper.querySelector('.card__main-image');
  const sizes = mainImage ? mainImage.getAttribute('sizes') : '';

  cardWrapper.querySelectorAll('.variant-pill[data-variant-image-src]').forEach((pill) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = pill.dataset.variantImageSrc;
    if (pill.dataset.variantImageSrcset) link.imageSrcset = pill.dataset.variantImageSrcset;
    if (sizes) link.imageSizes = sizes;
    document.head.appendChild(link);
  });
}

function applyVariantImage(pill, cardWrapper) {
  const mainImage = cardWrapper.querySelector('.card__main-image');
  if (!mainImage) return;

  if (mainImage.dataset.currentVariantSrc !== pill.dataset.variantImageSrc) {
    mainImage.src = pill.dataset.variantImageSrc;

    if (pill.dataset.variantImageSrcset) {
      mainImage.srcset = pill.dataset.variantImageSrcset;
    }

    if (pill.dataset.variantImageAlt) {
      mainImage.alt = pill.dataset.variantImageAlt;
    }

    mainImage.dataset.currentVariantSrc = pill.dataset.variantImageSrc;
    cardWrapper.classList.add('is-showing-variant-image');
  }

  const pillGroup = pill.closest('.variant-values');
  if (pillGroup) {
    pillGroup.querySelectorAll('.variant-pill.is-selected').forEach((selected) => {
      if (selected !== pill) selected.classList.remove('is-selected');
    });
  }
  pill.classList.add('is-selected');
}

function handleCardVariantPointerActivity(event) {
  const cardWrapper = event.target.closest('.card-wrapper');
  if (!cardWrapper) return;

  preloadCardVariantImages(cardWrapper);

  const pill = event.target.closest('.variant-pill[data-variant-image-src]');
  if (pill) applyVariantImage(pill, cardWrapper);
}

document.addEventListener('mouseover', handleCardVariantPointerActivity);
document.addEventListener('focusin', handleCardVariantPointerActivity);

/**
 * The "+N" pill (shown when a product has more colours than fit in the row)
 * opens the same quick-add popup as the card's normal quick-add button.
 */
function activateVariantMorePill(target) {
  const morePill = target.closest('.variant-pill.variant-more');
  if (!morePill) return false;

  const cardWrapper = morePill.closest('.card-wrapper');
  const quickAddTrigger = cardWrapper && cardWrapper.querySelector('.quick-add__submit');
  if (quickAddTrigger) quickAddTrigger.click();

  return true;
}

document.addEventListener('click', (event) => {
  activateVariantMorePill(event.target);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  if (!event.target.closest('.variant-pill.variant-more')) return;

  event.preventDefault();
  activateVariantMorePill(event.target);
});
